/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Body from "ui/kit/typography/Body";
import styles from "ui/feature/piece-play/common/piece-renderer/PieceRendererNoteTooltipRow.module.scss"

interface Props {
    title: string;
    onClick: () => void;
}

const PieceRendererNoteTooltipRow: React.FC<Props> = ({title, onClick}) => {
    return (
        <div className={styles.container} onClick={onClick}>
            <Body>{title}</Body>
        </div>
    )
}

export default PieceRendererNoteTooltipRow;
